import { LitElement, css, html } from 'lit';

export class ErrorRender extends LitElement {
  error: null;
  static properties = {
    error: {},
  };
  render() {
    return this.error
      ? html`
          <details>
            <summary>{this.error.message}</summary>
            <code>{error.stack}</code>
          </details>
        `
      : null;
  }
  static styles = css`
    :host {
      font-family: monospace;
      font-size: 0.9rem;
      padding: 5px;
    }
    summary {
      margin-block-end: 1rem;
    }
  `;
  static register(name = 'yh-error') {
    if (!customElements.get(name)) {
      customElements.define(name, ErrorRender);
    }
  }
}
